interface Props {
  titulo: string;
  fase: string;
}

export function PaginaEnConstruccion({ titulo, fase }: Props) {
  return (
    <section className="rounded-lg border border-dashed border-armazon-300 bg-white p-10 text-center">
      <h2 className="text-lg font-semibold text-armazon-900">{titulo}</h2>
      <p className="mt-2 text-sm text-armazon-500">
        Esta sección se construye en <span className="font-medium text-marca-700">{fase}</span>.
      </p>
    </section>
  );
}
